// Server-Sent Events streaming utility for truck events
export const streamTruckEvents = (cameraId, params, onData, onComplete, onError) => {
  if (!cameraId) {
    onError(new Error('Camera ID is required'));
    return () => {};
  }

  // Use environment variable for API URL if available
  const baseUrl = process.env.REACT_APP_API_URL || window.location.origin;
  const url = new URL(`/api/trucks/${cameraId}/stream`, baseUrl);

  // Add query parameters
  if (params.days) url.searchParams.append('days', params.days);
  if (params.startDate) url.searchParams.append('startDate', params.startDate);
  if (params.endDate) url.searchParams.append('endDate', params.endDate);

  console.log('Starting stream connection to:', url.toString());
  const eventSource = new EventSource(url.toString());

  eventSource.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      onData(data);

      if (data.type === 'complete') {
        eventSource.close();
        onComplete();
      }

      if (data.type === 'error') {
        eventSource.close();
        onError(new Error(data.message));
      }
    } catch (err) {
      console.error('Error parsing SSE data:', err);
      eventSource.close();
      onError(err);
    }
  };

  eventSource.onerror = (error) => {
    console.error('SSE connection error:', error);
    eventSource.close();
    onError(error);
  };

  // Return function to cancel the stream
  return () => eventSource.close();
};

// Test function for SSE connection
export const testStreamConnection = (onSuccess, onError) => {
  const baseUrl = process.env.REACT_APP_API_URL || window.location.origin;
  const url = new URL('/api/test-stream', baseUrl);
  console.log('Testing stream connection to:', url.toString());
  const eventSource = new EventSource(url.toString());
  
  eventSource.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      if (data.type === 'test') {
        eventSource.close();
        onSuccess(data);
      }
    } catch (err) {
      eventSource.close();
      onError(err);
    }
  };

  eventSource.onerror = (error) => {
    eventSource.close();
    onError(error);
  };

  // Auto-close after 5 seconds if no response
  setTimeout(() => {
    eventSource.close();
    onError(new Error('Test connection timeout'));
  }, 5000);

  return () => eventSource.close();
};